import {ErrorComponent} from '@refinedev/mui';
import {lazy} from 'react';
import {Route, Routes as RouterRoutes} from 'react-router';

import {Home} from '@pages/global/home';

const CreateUser = lazy(() => import('@pages/global/users/create-user'));
const EditUser = lazy(() => import('@pages/global/users/edit-user'));
const ListUser = lazy(() => import('@pages/global/users/list-user'));

export const Routes = () => {
  return (
    <RouterRoutes>
      <Route index element={<Home />} />
      <Route path="/users">
        <Route index element={<ListUser />} />
        <Route path="new" element={<CreateUser />} />
        <Route path="edit/:id" element={<EditUser />} />
      </Route>
      <Route path="*" element={<ErrorComponent />} />
    </RouterRoutes>
  );
};
